<template>
  <div class="tarif-section bg--color-01">
    <div class="container-wrapper bg--color-10">
      <div class="tarif-section__container container-new">
        <div class="tarif-section__content">
          <div class="tarif-section__image-side">
            <h2 class="tarif-section__title txt--color-05 txt--26px txt--44px--l txt--weight-700 txt--height-34px txt--height-58px--l mb-24 mb-0--l">
              {{ $t('cryptoCards.tariffSection.title') }}
            </h2>
            <img class="tarif-section__image" :src="require('@/assets/img/crypto-cards/tarif-section/graph.webp')" alt="graph image" width="100%">
          </div>
          <div class="tarif-section__info-side">
            <div class="tarif-section__items">
              <div
                v-for="(item, i) in items"
                :key="i"
                class="tarif-section__item bg--color-02 bor--radius-24 p-12 pl-20 p-8--l pl-24--l"
              >
                <p class="txt--color-05 txt--16px txt--26px--l txt--weight-700 txt--height-20px txt--height-34px--l mb-0">
                  {{ item.title }}
                </p>
                <div class="tarif-section__item-label bg--color-09 bor--radius-20 pt-4 pb-4 pl-8 pr-8">
                  <span class="txt--color-04 txt--16px txt--26px--l txt--weight-700 txt--height-20px txt--height-34px">
                    {{ item.label }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button-with-arrow class="tarif-section__btn" hide-icon size="l" @click="scrollToTopSection()">
          <div class="flx flx--items-end">
            <span>
              {{ $t('cryptoCards.tariffSection.linkOnOrderText') }}
            </span>
            <BoxIcon class="ml-6" />
          </div>
        </button-with-arrow>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowToOrder',
  components: {
    ButtonWithArrow: () =>
      import('@/components/welcome/elements/ButtonWithArrow.vue'),
    BoxIcon: () => import('@/assets/icons/crypto-cards/tarif-section/box.svg?inline'),
  },
  computed: {
    isMobile () {
      return this.$mq?.resize && this.$mq?.below(760)
    },
    items () {
      return [
        {
          title: this.$t('cryptoCards.tariffSection.list.0.value'),
          label: this.$t('cryptoCards.tariffSection.list.0.label'),
        },
        {
          title: this.$t('cryptoCards.tariffSection.list.1.value'),
          label: this.$t('cryptoCards.tariffSection.list.1.label'),
        },
        {
          title: this.$t('cryptoCards.tariffSection.list.2.value'),
          label: this.$t('cryptoCards.tariffSection.list.2.label'),
        },
        {
          title: this.$t('cryptoCards.tariffSection.list.3.value'),
          label: this.$t('cryptoCards.tariffSection.list.3.label'),
        },
        {
          title: this.$t('cryptoCards.tariffSection.list.4.value'),
          label: this.$t('cryptoCards.tariffSection.list.4.label'),
        },
        {
          title: this.$t('cryptoCards.tariffSection.list.5.value'),
          label: this.$t('cryptoCards.tariffSection.list.5.label'),
        },
      ]
    },
  },
  methods: {
    scrollToTopSection () {
      process.client &&
      setTimeout(() => {
        if (window) window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.tarif-section {
  &__container {
    display: flex;
    flex-direction: column;
    gap: toRem(24px);

    @include bp(m) {
      gap: toRem(42px)
    }
  }

  &__content {
    display: grid;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__image {
    display: block;
    margin: 0 auto;
    min-width: toRem(304px);
    max-width: toRem(532px);

    @include bp(m) {
      margin: 0;
    }
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: toRem(24px);

    @include bp(m) {
      gap: toRem(16px);
    }
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__item-label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: toRem(58px);
    min-width: toRem(95px);

    @include bp(l) {
      min-height: toRem(80px);
      min-width: toRem(130px);
    }
  }

  &__btn {
    @include bp(m) {
      max-width: max-content;
      margin: 0 auto;
    }
  }
}
</style>
